<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
    <BjInput
      v-model="remark"
      type="textarea"
      :placeholder="$t('inputText')"
      :maxlength="MAX_LENGTH.REMARK"
      show-word-limit
      clearable
      rows="5"
    ></BjInput>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('okText') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      dialogVisible: false,
      title: this.$t('approvedText'),
      remark: null,
    };
  },
  methods: {
    handleClose(done) {
      this.hide();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    show(title) {
      this.title = title;
      this.remark = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    confirm() {
      this.$emit('confirm', this.remark);
      this.hide();
    },
  },
};
</script>

<style></style>
